import React from 'react';
import ActionButton from './ActionButton';

const ServicesSection = ({ services }) => (
  <section className="services-section" id="services">
    <div className="section-heading">
      <div>
        <p className="eyebrow">What we offer</p>
        <h2>Event-ready service beyond the kitchen</h2>
      </div>
    </div>
    <div className="services-grid">
      {services.map((service) => (
        <article key={service.id} className="service-card">
          <div className={`service-badge service-${service.type}`}>
            {service.type}
          </div>
          <h3>{service.title}</h3>
          <ul>
            {service.bulletPoints.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
          <ActionButton variant="outline" size="xs" to={service.link}>
            {service.cta}
          </ActionButton>
        </article>
      ))}
    </div>
  </section>
);

export default ServicesSection;
